function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.5,
  y: 28.5,
  width: 4,
  height: 8,
  rx: 1.5,
  fill: "#0055A4",
  stroke: "#0055A4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 13.5,
  y: 21.5,
  width: 4,
  height: 15,
  rx: 1.5,
  fill: "#0055A4",
  stroke: "#0055A4"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 22.5,
  y: 25.5,
  width: 4,
  height: 11,
  rx: 1.5,
  fill: "#0055A4",
  stroke: "#0055A4"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 31.5,
  y: 17.5,
  width: 4,
  height: 19,
  rx: 1.5,
  fill: "#0055A4",
  stroke: "#0055A4"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 17.5,
  r: 2,
  fill: "#0055A4",
  stroke: "#0055A4"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 10.5,
  r: 2,
  fill: "#0055A4",
  stroke: "#0055A4"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 14.5,
  r: 2,
  fill: "#0055A4",
  stroke: "#0055A4"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 33.5,
  cy: 6.5,
  r: 2,
  fill: "#0055A4",
  stroke: "#0055A4"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.5 16.5L13.5 12.5L8.5 16.5Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 16.5L13.5 12.5",
  stroke: "#0055A4",
  strokeLinecap: "square"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5 13.5L17.5 11.5L22.5 13.5Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 13.5L17.5 11.5",
  stroke: "#0055A4",
  strokeLinecap: "square"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.5 13.5L31.5 8.5L26.5 13.5Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5 13.5L31.5 8.5",
  stroke: "#0055A4",
  strokeLinecap: "square"
});

function SvgDaxAnalyticsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxAnalyticsicon);
export default __webpack_public_path__ + "static/media/dax-analyticsicon.be18124e.svg";
export { ForwardRef as ReactComponent };